import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import base styles (will be created next)
import './services/theme.css';

// Render the app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
